<template>
  <v-card color="section" flat>
    <v-row class="ma-0">
      <v-col cols="12">
        <approved-domain-access-options />
      </v-col>
      <v-col cols="12">
        <approved-domain-accesses />
      </v-col>
    </v-row>
  </v-card>
</template>
<script setup>
import ApprovedDomainAccessOptions from "@/components/approved-domain/ApprovedDomainAccessOptions.vue";
import ApprovedDomainAccesses from "@/components/approved-domain/ApprovedDomainAccesses.vue";
</script>
